import OutOfCoin from './OutOfCoin';
export default OutOfCoin;
